import { Reveal } from "./Reveal";
import { ResponsivePicture } from "./ResponsivePicture";
import {
  royalWeddingPicture,
  usStampsPicture,
  worldStampsPicture,
  type PictureSet,
} from "@/lib/images";

const items: {
  tag: string;
  title: string;
  body: string;
  picture: PictureSet;
  objectPosition: string;
}[] = [
  {
    tag: "United States",
    title: "Early U.S. issues, starting with #1",
    body: "Mint sheets, booklets, booklet panes, plate blocks, and year sets of commemorative singles — including post-1939 US MNH plate blocks by want list.",
    picture: usStampsPicture,
    objectPosition: "object-center",
  },
  {
    tag: "Commonwealth",
    title: "Royal wedding souvenirs & sheets",
    body: "An especially deep selection of Royal Wedding souvenirs from Commonwealth countries, plus event and first day covers of all kinds.",
    picture: royalWeddingPicture,
    objectPosition: "object-center",
  },
  {
    tag: "Worldwide",
    title: "Pick-a-Packet & world stamps",
    body: "Better worldwide stamps (currently countries A–C), souvenir sheets, and our signature Pick-a-Packet booth — build your own from books and boxes at 10¢ each.",
    picture: worldStampsPicture,
    objectPosition: "object-center",
  },
];

export function Collections() {
  return (
    <section id="collections" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal>
            <p className="mb-4 text-xs uppercase tracking-[0.28em] text-accent">
              The Collection
            </p>
          </Reveal>
          <Reveal delay={1}>
            <h2 className="font-display text-4xl text-primary md:text-5xl">
              A growing archive, catalogued by hand.
            </h2>
          </Reveal>
          <Reveal delay={2}>
            <p className="mt-5 text-muted-foreground">
              From the earliest U.S. numbers to the deep Commonwealth cabinets,
              every stamp is inspected, priced fairly, and ready for the next
              album.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={i}>
              <article className="group relative flex h-full flex-col overflow-hidden border border-border bg-card shadow-[var(--shadow-stamp)] transition-transform duration-500 hover:-translate-y-1">
                <div className="relative overflow-hidden">
                  <ResponsivePicture
                    {...it.picture}
                    alt={it.title}
                    loading="lazy"
                    decoding="async"
                    className={`aspect-[4/3] w-full ${it.objectPosition} object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105`}
                  />
                  <div className="pointer-events-none absolute inset-0 border-[6px] border-dashed border-parchment/60 mix-blend-overlay" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <span className="text-[10px] uppercase tracking-[0.24em] text-accent">
                    {it.tag}
                  </span>
                  <h3 className="mt-2 font-display text-2xl text-primary">
                    {it.title}
                  </h3>
                  <p className="mt-3 text-sm text-muted-foreground">{it.body}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={3}>
          <p className="mt-12 text-center text-sm text-muted-foreground">
            Looking for a specific country or topic?{" "}
            <a
              href="mailto:saca@ix.netcom.com"
              className="underline decoration-accent underline-offset-4 hover:text-accent"
            >
              Email us
            </a>{" "}
            — the collection is always growing.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
